import type { IDataViewHeaderConfig, IUseDataViewOptions } from '@/domains/investor/components/DataView/DataView.types'
import { computed } from 'vue'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'
import { useReports } from '@/domains/investor/reports/composables/useReports.composable'
import { useReportsDataViewFilters } from '@/domains/investor/reports/composables/useReportsDataViewFilters'
import { ITEMS_PER_PAGE } from '@/domains/investor/merger-of-companies/const/mergerOfCompanies.const'
import { MERGER_OF_COMPANIES_CATEGORIES_SCOPE, MERGER_OF_COMPANIES_HEADER_CONFIG } from '../../merger-of-companies/const/mergerOfCompanies.const'
import { REPORTS_FILTERS_LABELS } from '@/domains/investor/reports/const/reportsLabels.const'

export const useMergerOfCompaniesDataView = async (options: IUseDataViewOptions = {}) => {
  const { useState } = useDataView()

  const {
    secondCategory,
    search,
    searchDraft,
    year,
    months,
    page,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    hasActiveFilters,
  } = useState({
    defaultCategoryScope: MERGER_OF_COMPANIES_CATEGORIES_SCOPE,
    options: {
      enableSearch: false,
      ...options,
    },
    useFilters: useReportsDataViewFilters,
  })

  const { reports, reportsColumns, total, isLoading } = await useReports(
    filters,
    page,
    ITEMS_PER_PAGE,
    'investor-merger-of-companies',
  )

  const headerConfig = computed<IDataViewHeaderConfig>(() => MERGER_OF_COMPANIES_HEADER_CONFIG)

  return {
    secondCategory,
    search,
    searchDraft,
    year,
    months,
    page,
    itemsPerPage: ITEMS_PER_PAGE,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    reports,
    reportsColumns,
    total,
    isLoading,
    hasActiveFilters,
    filterLabels: REPORTS_FILTERS_LABELS,
    headerConfig,
  }
}
